import { SET_SELECTED_LANGUAGE } from '../actions/selectedLanguageAction';

const initialState = {
  selectedLanguage: 'English',
};

const languageReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_LANGUAGE:
      const { selectedLanguage } = action.payload;
      return {
        ...state,
        selectedLanguage: selectedLanguage,
      };
    default:
      return state;
  }
};

export default languageReducer;
